import intl from 'react-intl-universal';
import { Box, Typography } from '@mui/material';
import { ConfirmModal } from 'shared/modals/confirmModal';
import PropTypes from 'prop-types';

const propTypes = {
  showWarnInvalidFileTypes: PropTypes.bool.isRequired,
  handleClosingWarnInvalidFileWindow: PropTypes.func.isRequired,
  invalidFiles: PropTypes.array.isRequired,
  oversizedFiles: PropTypes.array.isRequired,
};

const InvalidFileModal = ({
  showWarnInvalidFileTypes,
  handleClosingWarnInvalidFileWindow,
  invalidFiles,
  oversizedFiles,
}) => {
  return (
    <ConfirmModal
      isOpened={showWarnInvalidFileTypes}
      title={intl.get('new_modal_invalid_files_title')}
      bodyText={intl.get('new_modal_invalid_files_message_1')}
      onConfirm={handleClosingWarnInvalidFileWindow}
      confirmButtonColor="info"
      confirmButtonText={intl.get(
        'new_modal_exceed_upload_limit_button_close'
      )}>
      <Box data-testid="modal-child-box" sx={{ maxWidth: 'md' }}>
        {invalidFiles.length > 0 && (
          <>
            <Typography variant="h6">
              {intl.get('new_modal_invalid_files_message_2')}
            </Typography>
            {invalidFiles.map((file, index) => (
              <Typography variant="h6" style={{ color: 'red' }} key={index}>
                {file.path.replace(/^\.\//, '')}
              </Typography>
            ))}
          </>
        )}
        {oversizedFiles.length > 0 && (
          <>
            <Typography variant="h6" style={{ paddingTop: '20px' }}>
              {intl.get('new_modal_invalid_files_message_3')}
            </Typography>
            {oversizedFiles.map((file, index) => (
              <Typography variant="h6" style={{ color: 'red' }} key={index}>
                {file.path.replace(/^\.\//, '')}
              </Typography>
            ))}
          </>
        )}
      </Box>
    </ConfirmModal>
  );
};

InvalidFileModal.propTypes = propTypes;
export default InvalidFileModal;
